<template>
    <ul class="taggle_list">
        <li class="taggle" v-for="(tag_url, tag_name , index) in tagInfo" :key="index">
            <a :href="tag_url">{{ tag_name }}</a>
        </li>
    </ul>
</template>

<script>
export default {
    name: "MetadataTag",
    props: {
        tagInfo: {
            type: Object,
            required: true
        }
    }
}
</script>
